import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import * as Notify from "@repoflow/form-schema/notify";
import * as EntryQL from "queries/entry";
import { Component as Form } from "@repoflow/form-schema";
import { Mutation, Button, useSectionContext } from "@repoflow/components/section";
import * as appWidgets from "@shared/widgets/register";

export const Sidebar = () => null;

export const Indice = () => <BreadcrumbItem>Edit</BreadcrumbItem>;

// Hoisted for the reason routes/day/new gives. No `date`: it is the front of
// the key, so an entry logged on the wrong day is removed and added again.
const FIELDS = {
  "/Public/Entry/Update": {
    fields: [
      { property: "food" },
      { property: "serving" },
      { property: "meal" },
      { property: "calories" },
      { property: "protein" },
      { property: "carbs" },
      { property: "fat" },
    ],
  },
};

export const Content = ({ match: { params: { entryId } } }) => {
  const history = useHistory();
  const { values } = useSectionContext();
  const date = values?.date;

  return (
    <Mutation
      target={{ $ref: "/Public/Entry/Update" }}
      mutation={EntryQL.edit}
      update={EntryQL.update()}
      onMutate={({ handler, state: { values: current } }) => {
        // Only what the update input declares. The route's query seeds the form
        // with the whole row — entryId, date, timestamps — and EntryInputUpdate
        // would refuse the extra fields.
        const { meal, food, serving, calories, protein, carbs, fat } = current;
        handler({ variables: { entryId, input: { meal, food, serving, calories, protein, carbs, fat } } });
      }}
      onCompleted={() => {
        history.replace(date ? `/day/${date}` : `/day`);
      }}
      onError={(error) => {
        Notify.error(error.toString());
      }}
    >
      {MutationHandler}
    </Mutation>
  );
};

const MutationHandler = ({ schema, state, mutate, target, base }) => {
  const { values, setValues } = state;

  return (
    <Container className="mt-4" style={{ maxWidth: 760 }}>
      <Row>
        <Col>
          <Form
            schema={schema}
            target={target}
            values={values}
            widgets={appWidgets}
            config={FIELDS}
            onSubmit={() => mutate()}
            onChange={(vals) => setValues(vals)}
          >
            <Button type="submit">Save</Button>{" "}
            <Link className="btn btn-outline-danger" to={`${base}/remove`}>
              Remove
            </Link>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};
